import { components } from "@/api-schema";
import { commonColumns } from "./_constants/common-columns";

export type OccupationTableType = components["schemas"]["Occupation"];

export const occupationTableDefaultColumns = {
  columnName: commonColumns.columnName<OccupationTableType>(),
  columnDeletedAt: commonColumns.columnDeletedAt<OccupationTableType>(),
  columnUuid: commonColumns.columnUuid<OccupationTableType>(),
  columnCreatedAt: commonColumns.columnCreatedAt<OccupationTableType>(),
  columnUpdatedAt: commonColumns.columnUpdatedAt<OccupationTableType>(),
};
